export default "__VITE_ASSET__YTB2ueLI__"